import { render, staticRenderFns } from "./witnessrule_config_list.vue?vue&type=template&id=ed0ec080"
import script from "./witnessrule_config_list.vue?vue&type=script&lang=js"
export * from "./witnessrule_config_list.vue?vue&type=script&lang=js"
import style0 from "./witnessrule_config_list.vue?vue&type=style&index=0&id=ed0ec080&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports